import React, { Fragment, useEffect, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button, FormGroup, Col, Row } from 'reactstrap';
import TextField from '@material-ui/core/TextField';

const ModalPhaseServiceInAditional = ({
    activityMultiphase,
    opened,
    closeModal,
    appointmentPhase,
    validateHandlerAdditionalPhase,
    cantAppointments,
    modalMessageLimitExceded
}) => {

    const [namePhase, setNamePhase] = useState(null);

    useEffect(() => {
        console.log("appointmentActivity", activityMultiphase);
    }, []);

    const agendatePhase = () => {
        if(cantAppointments > 0)
        {
            appointmentPhase.nombre_fase = namePhase;
            console.log("appointmentPhase",appointmentPhase);
            validateHandlerAdditionalPhase(appointmentPhase);
        }
        else
        {
            modalMessageLimitExceded();
        }
    }

    return (
        <Fragment>
            <Modal
                open={opened}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <h4 className="bold-text">Cita de Fase</h4>
                    <label>Especifique los parametros de esta Fase</label>
                    <Row>
                        <Col md={4}>
                            <TextField
                                className="medical-material-form__field"
                                style={{ width: '100%' }}
                                id="document-number-standard-required"
                                label="Nombre de la Fase"
                                value={namePhase}
                                onChange={(e) => {
                                    setNamePhase(e.target.value);
                                }}
                            />
                        </Col>
                        <Col md={4}>
                            <TextField
                                className="medical-material-form__field"
                                disabled={true}
                                style={{ width: '100%' }}
                                id="document-number-standard-required"
                                label="Servicio"
                                value={activityMultiphase != null && activityMultiphase != undefined ? activityMultiphase.servicios : ""}
                            />
                        </Col>
                        <Col md={4}>
                            <TextField
                                className="medical-material-form__field"
                                disabled={true}
                                style={{ width: '100%' }}
                                id="document-number-standard-required"
                                label="Citas Faltantes por Asignar"
                                value={cantAppointments}
                            />
                        </Col>
                    </Row>
                    <div style={{ marginTop: 10, display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginRight: 10, marginLeft: 10 }}
                            variant="contained"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                        <Button
                            style={{ marginRight: 10, marginLeft: 10 }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                agendatePhase();
                            }}
                        >
                            Agendar Fase
                        </Button>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
};
export default ModalPhaseServiceInAditional;
